// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root-modal-stack[data-v-99f5d502] {\n  position: relative;\n  overflow: visible;\n  z-index: 40000000;\n}\n", ""]);
// Exports
module.exports = exports;
